





import Swiper from 'swiper';
import {Component, Vue} from 'vue-property-decorator';

@Component({
  name: 'Inspiration',
})
export default class Inspiration extends Vue {
  mounted() {
    const container = this.$el.querySelector<HTMLElement>('.swiper-container');
    if (!container) {
      return;
    }

    new Swiper(container, {
      effect: 'fade',
      keyboard: {
        enabled: true,
      },
      slideToClickedSlide: true,
      loop: true,
      autoplay: {
        delay: 4000,
      },
    });
  }
}
